import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {sorterNum} from 'Utils'
import {Table, Button} from 'antd'
import Controls from './Controls'

@inject('store') @observer
class PnlByTicker extends Component {
  componentDidMount() {
    this.props.store.backtest.tables.fetchPnlByTicker(this.props.id)
  }
  changePage = (page) => {
    this.props.store.backtest.tables.fetchPnlByTicker(this.props.id, page.current)
  }
  select = (selectedRowKeys) => {
    this.props.store.backtest.selectTickers(selectedRowKeys)
  }
  calculatePnlByTicker = () => {
    this.props.store.backtest.calculatePnlByTicker()
  }
  render() {
    const {backtest} = this.props.store
    const columns = [{
      title: 'Name',
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (text, record) => (
        <a onClick={() => {
          backtest.getTickerData(record.ticker)
          this.props.changeTab(record.ticker)
        }}>{record.name || '-'}</a>
      )
    }, {
      title: 'Capital',
      dataIndex: 'capital',
      sorter: (a, b) => sorterNum(a.capital, b.capital),
      render: text => '$' + text
    }, {
      title: 'Performance',
      sorter: (a, b) => sorterNum(a.performance, b.performance),
      render: (text, record) => (
        record.performance ? record.performance.toLocaleString('en-US', {maximumFractionDigits:2}) + '%' : '0.00'
      )
    }, {
      title: 'PnL',
      sorter: (a, b) => sorterNum(a.pnl, b.pnl),
      render: (text, record) => (
        record.pnl ? record.pnl.toLocaleString('en-US', {style: 'currency', currency: 'USD'}) : '0.00'
      )
    }, {
      title: 'Ticker',
      dataIndex: 'ticker',
      sorter: (a, b) => a.ticker.localeCompare(b.ticker)
    }]
    const {count, size, page, loading} = backtest.tables.pnlByTicker

    if (!loading && !size) {
      return (
        <div className='card'>
          <Button
            type='primary'
            onClick={this.calculatePnlByTicker}
          >
            Calculate PnL by ticker
          </Button>
        </div>
      )
    }
    return(
      <div className='card'>
        <Controls/>
        <Table
          rowSelection={{
            onChange: this.select
          }}
          onChange={this.changePage}
          dataSource={backtest.tables.filteredPnl}
          columns={columns}
          size='small'
          loading={loading}
          pagination={{
            pageSize: size,
            total: count,
            current: page
          }}
          locale={loading ? {
            emptyText: 'Loading'
          } : {
            emptyText: 'No Data'
          }}
        />
      </div>
    )
  }
}

export default PnlByTicker
